import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'
import Input from 'components/Input'
import { find, omit } from 'lodash'

const bem = new BEMHelper('yes-or-no')

export default function YesOrNo({
  options,
  values,
  onChange,
  narrow = false,
  highlightErrors = false,
}) {
  const handleToggleChange = (key) => ({ target: { value } }) => {
    const currentOption = find(values, { question: key }) || {}

    const answer = value === 'ja'

    onChange({
      ...omit(currentOption, ['notes']),
      question: key,
      answer,
      ...(answer ? { notes: currentOption.notes } : {}),
    })
  }

  const handleNoteChange = (key) => ({ target: { value } }) => {
    const currentOption = find(values, { question: key }) || {}

    onChange({
      ...currentOption,
      notes: value,
    })
  }

  const getAnswer = (question) => find(values, { question })?.answer
  const getNote = (question) => find(values, { question })?.notes || ''

  return (
    <div {...bem('', { narrow })}>
      {options.map(({ label, description, name, requiredValue, showInput, inputLabel }) => {
        // Decide if the button should show a warning (red background color)
        const isWarning =
          highlightErrors &&
          getAnswer(name) !== undefined &&
          requiredValue !== undefined &&
          getAnswer(name) !== requiredValue
        const modifiers = {
          error: isWarning,
        }

        return (
          <fieldset key={name} {...bem('item', modifiers)}>
            <div {...bem('content')}>
              <div>
                <legend {...bem('title')}>{label}</legend>
                {description && <p {...bem('description')}>{description}</p>}
              </div>

              <span {...bem('options')}>
                <label {...bem('option')}>
                  <input
                    type="radio"
                    value="ja"
                    name={name}
                    checked={getAnswer(name) === true}
                    {...bem('radio')}
                    onChange={handleToggleChange(name)}
                  />
                  <span {...bem('label')}>Ja</span>
                </label>
                <label {...bem('option')}>
                  <input
                    type="radio"
                    value="nei"
                    name={name}
                    checked={getAnswer(name) === false}
                    {...bem('radio')}
                    onChange={handleToggleChange(name)}
                  />
                  <span {...bem('label')}>Nei</span>
                </label>
              </span>
            </div>

            {showInput && (
              <div {...bem('input')}>
                <Input
                  label={inputLabel || 'Kommenter'}
                  autoFocus
                  value={getNote(name)}
                  onChange={handleNoteChange(name)}
                />
              </div>
            )}
          </fieldset>
        )
      })}
    </div>
  )
}

YesOrNo.propTypes = {
  options: T.array.isRequired,
  values: T.arrayOf(
    T.shape({
      question: T.string.isRequired,
      answer: T.bool.isRequired,
      notes: T.string,
    }),
  ).isRequired,
  onChange: T.func.isRequired,
  narrow: T.bool,
  highlightErrors: T.bool,
}
